import React from 'react';
import { VOTE_COLUMNS } from './votesMatrixUtils';

export interface VoteColumnLegendProps {
  className?: string;
}

const VoteColumnLegend: React.FC<VoteColumnLegendProps> = ({ className = '' }) => (
  <div
    className={`flex flex-wrap gap-x-4 gap-y-2 text-xs text-text-secondary dark:text-text-dark-secondary ${className}`}
  >
    {VOTE_COLUMNS.map(col => (
      <span key={col.type}>
        <strong className="text-text-primary dark:text-text-dark-primary">{col.label}</strong> = {col.title}
      </span>
    ))}
    <span className="text-text-tertiary dark:text-text-dark-tertiary italic">
      Cell format: {VOTE_COLUMNS.map(col => col.label).join(' / ')}
    </span>
  </div>
);

export default VoteColumnLegend;
